import { render, staticRenderFns } from "./closureCheck.vue?vue&type=template&id=056ff29b"
import script from "./closureCheck.vue?vue&type=script&lang=js"
export * from "./closureCheck.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('056ff29b')) {
      api.createRecord('056ff29b', component.options)
    } else {
      api.reload('056ff29b', component.options)
    }
    module.hot.accept("./closureCheck.vue?vue&type=template&id=056ff29b", function () {
      api.rerender('056ff29b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/EnduserDeclarationAdmin/closureCheck.vue"
export default component.exports